
<div style="padding:1rem;" class="animated faster fadeInUp">

	<form #extraForm="ngForm" class="exoffers-container" *ngIf="extraOffers">

		<!--<div class="_title">{{'extraOffersCaption'| objTranslate: $storage.config.settings: 'TD.additional_offers'}}</div>-->
		<div class="_title mb-3 mt-2">{{'extraOffersDesc'| objTranslate: $storage.config.settings: 'TD.select_additional_offers'}}</div>
		<div class="my-panel">
			<div class="my-panel-body" style="padding:16px 0 0 0">
				@if(extraOffers.hasExtraOffers) {
				<div class="table-extras">
					@for (_offer of extraOffers.offers; track _offer) {
						<div class="table-extras-row">
							<button type="button" color="accent" mat-icon-button (mousedown)="addExtraOffer(_offer, -1)"
									[disabled]="_offer.count < 1">
								<mat-icon svgIcon="minus_circle"></mat-icon>
							</button>

							<div class="table-extras-row-caption" [ngClass]="{'text-muted':!_offer.count}">
								<span>{{ _offer.displayName }}</span>
								<b *ngIf="_offer.count" [class.text-highlight]="_offer.count">({{ _offer.count }}
									/{{ _offer.maxCount }})</b>
							</div>

							<button type="button" color="accent" mat-icon-button (mousedown)="addExtraOffer(_offer, 1)"
									[disabled]="_offer.count == _offer.maxCount">
								<mat-icon svgIcon="plus_circle"></mat-icon>
							</button>
						</div>
					}
				</div>
				<hr />
				}

				@if(extraOffers.hasExtraOffersGroups) {
					@for (group of extraOffers.groups; track group) {
						<div>
							<div class="_sub-title">
								<div>{{ group.name }}</div>

								<div class="flex-center-middle text-xs text-highlight mt-1">
									<div>{{ group.$info }}</div>
									<div *ngIf="group.count">({{ group.count }}/{{ group.maxCount }})</div>
								</div>
							</div>
							<div class="table-extras">
								<div class="table-extras-row" *ngFor="let _offer of group.offers">
									<button type="button" color="accent" mat-icon-button
											(mousedown)="addGroupOffer(group, _offer, -1)"
											[disabled]="_offer.count < 1">
										<mat-icon svgIcon="minus_circle"></mat-icon>
									</button>

									<div class="table-extras-row-caption" [ngClass]="{'text-muted':!_offer.count}">
										<span>{{ _offer.displayName }}</span>
										<b *ngIf="_offer.count"
										   [class.text-highlight]="_offer.count">({{ _offer.count }})</b>
									</div>

									<button type="button" color="accent" mat-icon-button
											(mousedown)="addGroupOffer(group, _offer, 1)"
											[disabled]="group.count == group.maxCount">
										<mat-icon svgIcon="plus_circle"></mat-icon>
									</button>
								</div>
							</div>
							<hr/>
						</div>
					}
				}

				@if(extraOffers.hasExtraQuestions) {
				<div style="text-align:start; display:inline-block;max-width: 500px;">
					@for (question of $storage.catalog.extraQuestions | filterBy:{ _visible: true}; let ind = $index; track question) {
						<div class="mb-4">
							@if (question.disabled) {
								<mat-checkbox color="accent" [checked]="question.active" [disabled]="true">
									<span
										style="white-space: normal; line-height: 1.1;">{{ question.displayName }}</span>
								</mat-checkbox>
							} @else {
								<mat-checkbox color="accent"
											  [ngClass]="{'check-required': !question.active && question.requiereSelection && extraFormSubmitted}"
											  [(ngModel)]="question.active" [name]="'chkq_' + ind"
											  [required]="question.requiereSelection">
									<span
										style="white-space: normal; line-height: 1.1;">{{ question.displayName }}</span>
								</mat-checkbox>
							}
						</div>
					}
				</div>
				}
			</div>
		</div>
	</form>
</div>

<div class="p-3 pb-4 fixed-bottom">
	<button mat-raised-button color="accent" class="lg main-continue-btn" type="button" (mousedown)="continue()">
		<div class="_inner">
			<span>{{"continue" | translate}}</span>
			<b>{{($storage.order.grandTotal) | lcurrency}}</b>
			<div class="_cont rotate-rtl"><mat-icon svgIcon="arrow_next"></mat-icon></div>
		</div>
	</button>
</div>
